export default {"src":"/_next/static/media/logo.54780b0c.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};